require('./bootstrap');

import FixHeaderMobile from './modules/fix-header-mobile';
import MobileMenu from './modules/mobile-menu';
import SwiperMain from './modules/swiper-main';
import FixNabvar from './modules/fix-navbar';
import SwiperProd from './modules/swiper-production';
import Inputmask from './modules/inputmask';
import Stepper from './modules/stepper';
import Map from './modules/map';
import Scroll from './modules/scroll-to-section';
import Ajax from './modules/ajax';
import SubmitOrderForm from './modules/submit-order-form';
import SubmitCallbackForm from './modules/submit-callback-form';
import UpdateContentOrderModal from './modules/update-content-order-modal';
import SubmitFindOutCostForm from './modules/submit-find-out-cost';
import SubmitOrderAddressForm from './modules/submit-order-address-form';

let fixHeaderMobile = new FixHeaderMobile();
let mobileMenu = new MobileMenu();
let swiperMain = new SwiperMain();
let fixNabvar = new FixNabvar();
let swiperProd = new SwiperProd();
let inputmask = new Inputmask();
let stepper = new Stepper();
let map = new Map();
let scroll = new Scroll();
let ajax = new Ajax();
let submitOrderForm = new SubmitOrderForm();
let submitCallbackForm = new SubmitCallbackForm();
let updateContentOrderModal = new UpdateContentOrderModal();
let submitFindOutCostForm = new SubmitFindOutCostForm();
let submitOrderAddressForm = new SubmitOrderAddressForm();
